import React, { useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
import store from "store";
import styles from "./index.module.scss";
import { Form, Select, Input, Avatar } from "antd";
import { ListItemProps } from "@/components/Xt/Dropdown";
import useAsyncEffect from "@/hooks/useAsyncEffect";
import { Storage } from "@xt/xtbase";
import defaultCode from "@/components/App/Country/defaultCode";
import { CountryProps } from "@/store/user";
import AuthUpload from "../_CMPT/Upload";
import { axiosThrottle } from "@/utils/method";
import { waitRes } from "@/utils/axios";
import { getAuthAccess, postHumanAuth } from "@/api/uaapi/user";
import { useRouter } from "next/router";
import QrCode from "@xt/QrCode";
import { Modal as AppPasskeyModal } from "@xt/Passkey";
interface PrimaryProps extends BaseCompProps {
  attr?: any;
}
const { useTranslation } = Hooks;
const { useForm } = Form;
const initForm = {
  country: "" || 0,
  cardType: undefined,
  realName: "",
  videoUrl: "",
  frontImg: "",
  backImg: "",
};
type FormDataType = typeof initForm;
const uploadUrl = "/exchange-user/api/web/1_0_0/uploadFile";
const Primary: React.FC<PrimaryProps> = ({ className }) => {
  const t = useTranslation();
  const router = useRouter();
  const {
    authInfo: { userAuthInfoVo },
    getCountryInfo,
  } = store.user;
  const { app, user } = store;
  const [formIns] = useForm();
  const [formData, setFormData] = useState({ ...initForm });
  const [visibleSafe, setVisibleSafe] = useState(false);
  const [countryItem, setCountryItem] = useState({} as CountryProps);
  const [authNumberList, setAuthNumberList] = useState([]);
  // useEffect
  useAsyncEffect(async () => {
    const { data, err } = await getCountryInfo("MOBILE");
    if (err) {
      if (formData.country) return;
      const code = getLocalCode() || "91";
      const defaultItem = defaultCode.find((obj) => obj.code === code);
      setCountryItem(defaultItem!);
      setFormData({ ...formData, country: code });
      getAccessTokenData(code);
    } else {
      const { userCountryCode, countryList } = data;
      store.user.updateState({ countryList: countryList?.sort((a, b) => +a.code - +b.code) });
      const countryId = Storage.get("countryId") || 206; // 206:默认香港
      if (formData.country) return;
      const cur = countryList?.find((obj) => obj.id === countryId);
      if (cur) {
        setCountryItem(cur!);
        setFormData({ ...formData, country: cur.xtId! });
        getAccessTokenData(cur.xtId!);
      } else {
        const code = userCountryCode || getLocalCode() || "91";
        /* eslint-disable */
        setCountryItem(countryList?.find((obj) => obj.code === code)!);
        setFormData({ ...formData, country: code });
        getAccessTokenData(code);
      }
    }
  }, []);

  useEffect(() => {
    formIns.setFieldsValue({ ...formData });
  }, [formData]);

  // useMemo
  const cardList = useMemo(() => {
    return [
      { value: 1, label: t("account.idCard") },
      { value: 2, label: t("account.passport") },
      { value: 3, label: t("account.drivingLicence") },
      { value: 4, label: t("account.otherCard") },
    ];
  }, []);
  const getLocalCode = () => Storage.get("countryCode") || Storage.get("zCountryCode");
  const onValuesChange = (changedValues: Partial<FormDataType>) => {
    const data = { ...formData, ...changedValues };
    setFormData(data);
  };
  const countrySelectChange = (key: string, item: ListItemProps<CountryProps>) => {
    setFormData({ ...formData, country: +key });
    setCountryItem(item);
    getAccessTokenData(+key);
  };

  const getAccessTokenData = async (country) => {
    const { err, data } = await waitRes(getAuthAccess, {
      errorPop: true,
      params: {
        countryId: country,
        type: 1,
      },
    });
    if (err) return;
    if (data.verifyCode) {
      setAuthNumberList(data.verifyCode.toString().split(""));
    }
  };

  const disabledForm = useMemo(() => {
    const formFlag = Object.keys(formData).some((key) => !formData[key]);
    return formFlag;
  }, [formData]);

  const submitForm = axiosThrottle(async (unlock, { faResultId }) => {
    const { data, err } = await waitRes(postHumanAuth, {
      successPop: true,
      errorPop: true,
      data: { ...formData, faResultId, countryId: countryItem.id, countryCode: countryItem.code },
    });
    unlock();
    setVisibleSafe(false);
    if (!err) {
      store.user.getUserInfo();
      router.push("/accounts/user/verification");
    }
  });
  const submitData = () => {
    // 11111
    setVisibleSafe(true);
  };

  const getList = useMemo(() => {
    // 老接口获取国家列表
    const newList = user.countryList?.map((item) => ({
      ...item,
      meta: true,
      dropAvatar: <Avatar src={item.nationalFlagIcon}></Avatar>,
    }));
    return newList;
  }, [user.countryList]);

  const countryItemData = useMemo(() => {
    const item = getList?.find((item) => item.xtId == formData.country);
    return item;
  }, [getList, formData.country]);

  console.log(countryItemData, "countryItemData");
  return (
    <div className={cx(styles.auth_form, styles.account_container, className)}>
      <div className={styles["auth_form_content"]}>
        <div>
          <Form form={formIns} name="primaryForm" initialValues={formData} onValuesChange={onValuesChange}>
            {countryItemData && (
              <Form.Item name="country">
                <div className={cx(styles["auth_form_select"], styles.countryItem)}>
                  <Avatar src={countryItemData.nationalFlagIcon}></Avatar>
                  <span>+{countryItemData.code}</span>
                  <span>[{countryItemData.name}]</span>
                  <span>[{countryItemData.des}]</span>
                </div>
              </Form.Item>
            )}

            <Form.Item name="cardType">
              <Select className={cx(styles["auth_form_select"], "xt-drop-icon")} placeholder={t("account.CertificateType")} options={cardList} />
            </Form.Item>
            <Form.Item name="realName" rules={[{ required: true, message: t("account.RealNameVerify") }]}>
              <Input className={cx(styles["auth_form_input"])} autoComplete="new-text" placeholder={t("account.RealName")} />
            </Form.Item>
            <Form.Item name="cardId" rules={[{ required: true, message: t("account.CertificateNumberVerify") }]}>
              <Input className={cx(styles["auth_form_input"])} autoComplete="new-text" placeholder={t("account.CertificateNumber")} />
            </Form.Item>
            <div className={styles["auth_form_card"]}>
              <div className={cx(styles["auth_form_card_list"], styles["col-md-4"])} style={{ paddingLeft: 0 }}>
                <div
                  className={cx(styles["form_bg"], styles["form_Idcard_first"])}
                  style={{ backgroundImage: `url(${require(`@/assets/images/account/a-file-id-1${app.isDark ? "-night" : ""}.png`).default})` }}
                >
                  <AuthUpload
                    limit={5120}
                    params="frontImg"
                    action={uploadUrl}
                    onChangeImg={(key, val) => {
                      setFormData({ ...formData, [key]: val });
                    }}
                  />
                  <p>{t("account.FrontOf")}</p>
                </div>
              </div>
              <div className={cx(styles["auth_form_card_list"], styles["col-md-4"])}>
                <div
                  className={cx(styles["form_bg"], styles["form_Idcard_sec"])}
                  style={{ backgroundImage: `url(${require(`@/assets/images/account/a-file-id-2${app.isDark ? "-night" : ""}.png`).default})` }}
                >
                  <AuthUpload
                    limit={5120}
                    params="backImg"
                    action={uploadUrl}
                    onChangeImg={(key, val) => {
                      setFormData({ ...formData, [key]: val });
                    }}
                  />
                  <p>{t("account.BackOf")}</p>
                </div>
              </div>
            </div>
            <div className={styles["form_group"]}>
              <p className={styles["advanceds"]}>{t("account.reverifyVideo")}</p>
              <div className={styles["form_confirm_sign"]}>
                <p>
                  {t("account.followingNumbersInTheVideo")}:<b className={styles["text-danger"]}>{authNumberList.join("")}</b>
                  {t("account.webAfterRecording")},{t("account.videoLimit")}
                </p>
              </div>
              <ul className={styles["auth_number"]}>
                {authNumberList.map((n, i) => (
                  <li key={i}>{n}</li>
                ))}
              </ul>
              <div className={styles["auth_video"]}>
                <div className={styles["video_rect"]}>
                  <div
                    className={styles["video_con"]}
                    style={{ backgroundImage: formData.videoUrl ? "none" : `url(${require(`@/assets/images/account/a-file-video.png`).default})` }}
                  >
                    <AuthUpload
                      value={formData.videoUrl}
                      onChangeImg={(key, val) => {
                        setFormData({ ...formData, [key]: val });
                      }}
                      params="videoUrl"
                      type="video"
                      accept=".ogg,.mp4,.webm,.3gp,.mov"
                    />
                  </div>
                </div>
                <div className={styles["video_dashed"]}></div>
                {/* <div className={styles["qrcode_video"]}>
                  <QrCode size={132} isShowLogo />
                  <p className={styles["scan_confirm"]}>{t("account.applyForVerification")}</p>
                </div> */}
              </div>
            </div>
            <div className={cx(styles["base-btn"], disabledForm && styles["disabledBtn"])} onClick={submitData}>
              {t("cmpt.submit")}
            </div>
          </Form>
        </div>
      </div>
      <div className={styles["form_sign"]}>
        <div className={styles["form_sign_list"]}>
          <h6>{t("account.Notices")}</h6>
          <p>* {t("account.validCertificates")}</p>
          <p>* {t("account.RealnameAuthentication")}</p>
          <p>* {t("account.limit1M")}</p>
          <p>* {t("account.uploadedPicturesIncludeNew")}</p>
        </div>
      </div>
      {/* 安全验证 */}
      <AppPasskeyModal
        faBizType={56}
        dynamicCodeType={"USER_2023"}
        successCallback={submitForm}
        open={visibleSafe}
        onClose={() => setVisibleSafe(false)}
        isDark={store.app.isDark}
        userInfo={store.user.userInfo}
      />
    </div>
  );
};
export default observer(Primary);
